import * as ActionTypes from '../ActionTypes'

export const setFile = (fileId, fileName) => ({
  type: ActionTypes.SET_TRANSCRIBE_FILE,
  payload: {
    fileId,
    fileName,
  },
})

export const clearTask = () => ({
  type: ActionTypes.CLEAR_TRANSCRIBE_TASK,
  payload: {
  },
})
export const updateTask = ({ taskId, status, progress, error, result }) => ({
  type: ActionTypes.UPDATE_TRANSCRIBE_TASK_STATUS,
  payload: {
    taskId, status, progress, error, result,
  },
})


export const setTranscribeModels = transcribeModels => ({
  type: ActionTypes.SET_TRANSCRIBE_MODELS,
  payload: {
    transcribeModels,
  },
})
